import { Configuration, PopupRequest } from '@azure/msal-browser';

// Determinar redirect URI basado en el entorno
const getRedirectUri = () => {
  // Si está explícitamente configurado, usarlo
  if (process.env.REACT_APP_REDIRECT_URI) {
    return process.env.REACT_APP_REDIRECT_URI;
  }
  
  // En desarrollo local, usar localhost
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000';
  }
  
  // En producción, usar el origen actual
  return window.location.origin;
};

// Debug: verificar qué URL se está usando
console.log('Environment:', process.env.NODE_ENV);
console.log('Redirect URI:', getRedirectUri());
console.log('Client ID:', process.env.REACT_APP_AZURE_CLIENT_ID);
console.log('Tenant ID:', process.env.REACT_APP_AZURE_TENANT_ID);


// Configuración MSAL para Azure AD / Office 365
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || 'your-client-id', // Application (client) ID
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'your-tenant-id'}`, // Directory (tenant) ID
    redirectUri: getRedirectUri(), // Must be registered as a SPA redirectURI on your app registration
    postLogoutRedirectUri: getRedirectUri(), // Must be registered as a SPA redirectURI on your app registration
  },
  cache: {
    cacheLocation: 'localStorage', // Usar localStorage para mantener sesión al recargar página
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // LogLevel.Error
            console.error(message);
            return;
          case 1: // LogLevel.Warning
            console.warn(message);
            return;
          case 2: // LogLevel.Info
            console.info(message);
            return;
          case 3: // LogLevel.Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'User.Read.All'],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
  graphUsersEndpoint: 'https://graph.microsoft.com/v1.0/users',
};

// Add here scopes for access token to be used at MS Graph API endpoints.
export const tokenRequest = {
  scopes: ['User.Read', 'User.ReadBasic.All', 'User.Read.All'],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

// Token request for your API
export const apiTokenRequest = {
  scopes: [`api://${process.env.REACT_APP_AZURE_CLIENT_ID || 'your-client-id'}/access_as_user`],
  forceRefresh: false,
};